import { render, staticRenderFns } from "./BenefitsAssign.vue?vue&type=template&id=ac5177fe"
import script from "./BenefitsAssign.vue?vue&type=script&lang=js"
export * from "./BenefitsAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports